// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3FTr8","signatureButtonsRight":"ModalSign_signatureButtonsRight__2WflR"};